module.exports = __webpack_public_path__ + "img/dink-bedroom-4.c7f1dac7.jpeg";